import { IReport } from '@opengov/reporting-types';
import { createSelector } from 'reselect';

import { reportFormSelectors } from '../../common/forms/reportForm/state';
// Concrete module, not the `selectors` barrel: the barrel re-exports selectReportNavigation, which
// pulls in reportEffects, which imports this file back — the cycle left selectModifiedReport
// undefined at createSelector time.
import { selectCurrentReport } from '../../common/report/selectors/reportSelectors';
import { reportUpdateSelector } from '../../reportUpdate/state';

export const selectModifiedReport = createSelector(
  [reportUpdateSelector],
  (reportUpdateState) => reportUpdateState.modifiedReport
);

/**
 * Whether the settings draft still differs from the saved report. Compares only the fields this page
 * edits rather than the whole record, so an unrelated field the server rewrites on load (timestamps,
 * defaultReportConfiguration) cannot read as a pending user edit.
 */
export const selectModifiedReportHasChanges = createSelector(
  [selectModifiedReport, selectCurrentReport],
  (modifiedReport, currentReport) => {
    // Both inputs are typed as always resolving, but neither does early on: the settings draft is
    // empty until the form initialises, and the saved report is a lookup that misses while the
    // report is still loading. Without the guard a half-loaded page reads as edited.
    const draft = modifiedReport as IReport | undefined;
    const saved = currentReport as IReport | undefined;
    if (!draft || !saved) return false;
    return (
      draft.title !== saved.title || draft.description !== saved.description || draft.visibility !== saved.visibility
    );
  }
);

const selectors = reportFormSelectors(reportUpdateSelector);

export const selectModifiedReportFormDescriptionValidationState = selectors.selectReportFormDescriptionValidationState;
export const selectModifiedReportFormTitleValidationState = selectors.selectReportFormTitleValidationState;
export const selectModifiedReportFormValidationState = selectors.selectReportFormValidationState;
export const selectModifiedReportTypeState = selectors.selectReportFormTypeState;
